import {
  Box,
  Table,
  Text,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  BoxProps,
  Icon,
} from '@chakra-ui/react';
import { useCallback, useMemo } from 'react';
import { RiPencilLine } from 'react-icons/ri';
import { LinkButton } from '../../../../../../../components/LinkButton';
import { Pagination } from '../../../../../../../components/Pagination';
import { TableFilters } from '../../../../../../../components/TableFilters';
import { IUserListItem } from '../../../../../../../services/Users/ListUsersService';

export interface IUser extends IUserListItem {
  formattedDate: string;
}

interface IOnFilterProps {
  filter: string;
  value: string;
}

interface IUserTableProps extends BoxProps {
  users: IUser[];
  onFilter?: (data: IOnFilterProps) => void;
  defaultFilterBy?: string;
  defaultSortBy?: string;
  onSort?: (sort: 'name' | 'phone' | 'email' | 'createdAt') => void;
  onOrder?: (order: 'ASC' | 'DESC') => void;
  currentPage?: number;
  onPageChange?: (page: number) => void;
  totalPages?: number;
}

export const UserTable = ({
  users,
  onFilter,
  defaultFilterBy,
  defaultSortBy,
  onSort,
  onOrder,
  currentPage,
  onPageChange,
  totalPages,
  ...rest
}: IUserTableProps): JSX.Element => {
  const handleSort = useCallback(
    (sort: string) => {
      if (onSort) {
        onSort(sort as 'name' | 'phone' | 'email' | 'createdAt');
      }
    },
    [onSort],
  );

  const filterOptions = useMemo(
    () => [
      {
        label: 'Nome',
        value: 'name',
      },
      {
        label: 'E-mail',
        value: 'email',
      },
      {
        label: 'Telefone',
        value: 'phone',
      },
    ],
    [],
  );

  const orderingOptions = useMemo(
    () => [
      {
        label: 'Nome',
        value: 'name',
      },
      {
        label: 'Comissão',
        value: 'commission',
      },
      {
        label: 'Telefone',
        value: 'phone',
      },
      {
        label: 'E-mail',
        value: 'email',
      },
      {
        label: 'Data de cadastro',
        value: 'createdAt',
      },
    ],
    [],
  );

  return (
    <Box {...rest}>
      <TableFilters
        filterOptions={onFilter ? filterOptions : undefined}
        orderingOptions={orderingOptions}
        onFilter={onFilter}
        defaultFilterBy={defaultFilterBy}
        defaultSortBy={defaultSortBy}
        onSort={handleSort}
        onOrder={onOrder}
      />

      <Table colorScheme="blue" mt="4">
        <Thead>
          <Tr>
            <Th>Usuário</Th>
            <Th>Telefone</Th>
            <Th>Data de cadastro</Th>
            <Th w="8" />
          </Tr>
        </Thead>

        <Tbody>
          {users.map((user) => (
            <Tr key={user.id}>
              <Td>
                <Box>
                  <Text fontWeight="bold">{user.name}</Text>
                  <Text fontSize="sm" color="gray.500">
                    {user.email}
                  </Text>
                </Box>
              </Td>

              <Td>{user.phone}</Td>
              <Td>{user.formattedDate}</Td>

              <Td>
                <LinkButton
                  icon={<Icon as={RiPencilLine} fontSize="16" />}
                  to={{
                    pathname: '/users/details',
                    state: {
                      userId: user.id,
                    },
                  }}
                >
                  Detalhes
                </LinkButton>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      {!!currentPage && !!onPageChange && !!totalPages && totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      )}
    </Box>
  );
};
